import { extend } from 'flarum/extend';
import HeaderSecondary from 'flarum/components/HeaderSecondary';

const HideSearchForRegularUsers = () => {

    extend(HeaderSecondary.prototype, 'items', function(items) {

        if(items.items && items.items.search) {
          const user = app.session.user;
            if (user == null || user.data.attributes.canEdit === false) {
                // removing the item from here, will remove it from the DOM
                delete items.items.search;
            }
        }
    });
};

export default HideSearchForRegularUsers;
